
import React, { useState } from 'react';
import MainContext from './MainContext';
import { signup, login, googleLogin, forgotpassowrd, getAllUsers, OwnerVarification } from './contextPages/AuthContexts';
import {
  fetchAllClients,
  fetchClientByNumber,
  fetchClientById,
  fetchBillByClientNumber,
  createClient,
  updateClient,
  sendBulkSms,
  deleteClient,
  createManyClient,
  buyMembership,
  fetchVisitedClinetAnalytics,
  getClientReviews,
  submitwalletPayment,
  getAllLossClient,
  fetchDayWiseReport,
  extendMembership,
  getExpiredMemberships,
  updateMembershipBill,
  updatePackageBill,
} from './contextPages/ClientContexts';
import {
  fetchAllProducts,
  createProduct,
  createManyProduct,
  deleteManyProduct,
  deleteProduct,
  updateProduct,
  addProductCount,
  getProductDetails,
} from './contextPages/ProductContexts';
import {
  createConsumeProduct,
  fetchAllConsumeProducts,
  fetchConsumeProductById,
  addConsumeableProductCount,
  updateConsumeableProduct,
  deleteConsumeableProduct,
  fetchServicesBillById,
  saveConsumedProducts,
  createManyConsumeableProduct,
} from './contextPages/ConsumeableProductsContexts';
import {
  fetchAllMemberships,
  fetchMembershipDetail,
  createMembership,
  updateMembership,
  deleteMembership,
  createPackages,
  fetchAllPackages,
  fetchSinglePackageDetail,
  updatePackage,
  buyPackage,
  deletePackages,
  bulkUploadMembership
} from './contextPages/MembershipContexts';
import {
  fetchAllAppointments,
  fetchStaffAppointmentsDateWise,
  fetchAppointmentById,
  updateAppointment,
  createAppointment,
  deleteAppointment,
  updateAppointmentStatus,
  assignAppointment,
  createWebAppointmentBookingLink,
  fetchAppointmentAnalytics,
  getAppointmentPageData,
} from './contextPages/AppointmentContexts';
import {
  fetchAllStaffs,
  getAllStaff,
  createStaff,
  updateStaff,
  deleteStaff,
  getStaffById,
  fetchAttendanceByStaffId,
  fetchOverview,
  staffCollection,
  changeStaffAccountStatus,
  staffStatusUpdate,
  fetchStaffWiseWork,
  staffWorkAnalysis,
  staffOverview,
  fetchSalarySlipById,
  fetchStaffAdvanceById,
  fetchStaffIncentiveById,
  setCalendarEntry,
  bulkSetCalendar,
  removeCalendarEntry,
  getStaffCalendar,
  getStaffCalendarView,
  getAllLeaveRequestsByBranch,
  updateLeaveStatus,
  fetchStaffLeaves,
} from './contextPages/StaffContexts';
import {
  fetchAllServices,
  getAllService,
  createService,
  updateService,
  deleteService,
  createManyService,
  deleteManyService,
  getServiceRemindersByBranch,
  updateServiceReminder,
  deleteServiceReminder,
} from './contextPages/ServiceContexts';
import {
  fetchAllBillings,
  fetchBillAnalytics,
  fetchBillById,
  createBilling,
  deleteBilling,
  fetchTotalSales,
  updateBill,
  clearRemainingAmount,
  fetchPackageBills,
  getGstData,
  fetchMemberAnalytixs,
  // new
  deletePackagebill,
  fetchDraftBill,
  createDraftBilling,
  fetchSingleBill,
  fetchPackageBillById,
  deleteDraftBill,
  fetchPackageAndMembershipBills,
  getWhatsAppTemplates,
  sendBulkWhatsApp,
  getOwnerIdByBranchId,
  fetchSalesExpenseSummary,
} from './contextPages/BillingContexts';
import {
  fetchAllBranch,
  createBranch,
  getBranch,
  deleteBranch,
  getFeedbackUrl,
  getBillUrl,
  updateGeoLocation,
  getBranchTimings,
  getBranchNotification
} from './contextPages/BranchContexts';
import { fetchAllFeedbacks, createFeedback } from './contextPages/FeedbackContexts';
import { fetchAllCategories, createCategory } from './contextPages/CategoryContext';
import {
  createCoupon,
  updateCoupon,
  fetchAllCoupon,
  deleteCoupon,
} from './contextPages/CouponContexts';
import {
  fetchAllExpenses,
  fetchExpenseAnalytics,
  fetchAllExpenseType,
  createExpense,
  createManyExpense,
  updateExpense,
  deleteExpense,
} from './contextPages/ExpenseContexts';
import {
  fetchAllEquiry,
  createClientEnquiry,
  updateClientEnquiry,
  deleteClientEnquiry,
} from './contextPages/ClientEnquiryContexts';
import { fetchOverviewData } from './contextPages/DashboardContexts';
import {
  fetchNotifications,
  fetchAccountExpiration,
  fetchRemainingMessages,
} from './contextPages/NotificationContexts';

import {
  monthwisesalesreport,
  monthwiseexpensereport,
  topperformer,
  staffperformance,
  topmembershippackages,
  topserviceproducts,
  getAvailableReportModels,
  exportReport,
  exportCombinedReport,
} from './contextPages/ReportContext';
import {getAllServiceCategories, serviceCreateCategory, serviceUpdateCategory} from './contextPages/serviceCategoryContext';
import {verifyGstin} from './contextPages/GstContext';
import {fetchAllWhatsappCampaigns , fetchWhatsappCampaignDetails} from './contextPages/WhatsappCampaignContexts' ;



const MainState = (props) => {
  const [activeBranchId, setActiveBranchId] = useState(null);
  const [branchData, setBranchData] = useState({});
  const [showMessage, setShowMessage] = useState({});

  return (
    <>
      <MainContext.Provider
        value={{
          activeBranchId,
          setActiveBranchId,

          branchData,
          setBranchData,

          showMessage,
          setShowMessage,

          fetchOverviewData,

          createCoupon,
          updateCoupon,
          fetchAllCoupon,
          deleteCoupon,

          fetchAllExpenses,
          fetchExpenseAnalytics,
          fetchAllExpenseType,
          createExpense,
          createManyExpense,
          updateExpense,
          deleteExpense,

          fetchAllBranch,
          createBranch,
          getBranch,
          deleteBranch,
          getFeedbackUrl,
          getBillUrl,
          getBranchTimings,
          getBranchNotification,
          updateGeoLocation,

          fetchAllStaffs,
          getAllStaff,
          createStaff,
          updateStaff,
          deleteStaff,
          getStaffById,
          fetchAttendanceByStaffId,
          fetchOverview,
          staffCollection,
          changeStaffAccountStatus,
          staffStatusUpdate,
          fetchStaffWiseWork,
          staffWorkAnalysis,
          staffOverview,
          fetchSalarySlipById,
          fetchStaffAdvanceById,
          fetchStaffIncentiveById,
          setCalendarEntry,
          bulkSetCalendar,
          removeCalendarEntry,
          getStaffCalendar,
          getStaffCalendarView,
          getAllLeaveRequestsByBranch,
          updateLeaveStatus,
          fetchStaffLeaves,

          fetchStaffAppointmentsDateWise,
          fetchAllAppointments,
          fetchAppointmentById,
          createAppointment,
          updateAppointment,
          updateAppointmentStatus,
          deleteAppointment,
          assignAppointment,
          createWebAppointmentBookingLink,
          fetchAppointmentAnalytics,
          getAppointmentPageData,

          fetchAllClients,
          fetchClientByNumber,
          fetchClientById,
          fetchBillByClientNumber,
          createClient,
          updateClient,
          sendBulkSms,
          deleteClient,
          createManyClient,
          buyMembership,
          fetchVisitedClinetAnalytics,
          getClientReviews,
          submitwalletPayment,
          getAllLossClient,

          fetchAllMemberships,
          fetchMembershipDetail,
          createMembership,
          updateMembership,
          deleteMembership,
          createPackages,
          fetchAllPackages,
          fetchSinglePackageDetail,
          updatePackage,
          buyPackage,
          deletePackages,
          bulkUploadMembership,

          fetchAllProducts,
          createProduct,
          deleteProduct,
          deleteManyProduct,
          updateProduct,
          createManyProduct,
          addProductCount,
          getProductDetails,

          //new consumeable products
          createConsumeProduct,
          fetchAllConsumeProducts,
          fetchConsumeProductById,
          addConsumeableProductCount,
          updateConsumeableProduct,
          deleteConsumeableProduct,
          fetchServicesBillById,
          saveConsumedProducts,
          createManyConsumeableProduct,
          fetchDayWiseReport,
          extendMembership,
          getExpiredMemberships,
          updateMembershipBill,
          updatePackageBill,

          fetchAllServices,
          getAllService,
          createService,
          updateService,
          deleteService,
          createManyService,
          deleteManyService,
          getServiceRemindersByBranch,
          updateServiceReminder,
          deleteServiceReminder,

          fetchAllBillings,
          fetchBillAnalytics,
          fetchMemberAnalytixs,
          fetchBillById,
          createBilling,
          deleteBilling,
          fetchTotalSales,
          updateBill,
          clearRemainingAmount,
          fetchPackageBills,
          // new
          deletePackagebill,
          getGstData,
          fetchDraftBill,
          createDraftBilling,
          fetchSingleBill,
          fetchPackageBillById,
          deleteDraftBill,
          fetchPackageAndMembershipBills,
          getWhatsAppTemplates,
          sendBulkWhatsApp,
          getOwnerIdByBranchId ,
          fetchSalesExpenseSummary,

          fetchAllEquiry,
          createClientEnquiry,
          updateClientEnquiry,
          deleteClientEnquiry,

          fetchNotifications,
          fetchAccountExpiration,
          fetchRemainingMessages,

          fetchAllFeedbacks,
          createFeedback,

          fetchAllCategories,
          createCategory,

          signup,
          login,
          googleLogin,
          forgotpassowrd,
          getAllUsers,
          OwnerVarification,

           monthwisesalesreport,
          monthwiseexpensereport,
          topperformer,
          staffperformance,
          topmembershippackages,
          topserviceproducts,
          getAvailableReportModels,
          exportReport,
          exportCombinedReport,

          serviceUpdateCategory,
          serviceCreateCategory,
          getAllServiceCategories,

          verifyGstin,

          fetchAllWhatsappCampaigns,
          fetchWhatsappCampaignDetails,
        }}
      >
        {props.children}
      </MainContext.Provider>
    </>
  );
};

export default MainState;
